import { HintVariant } from '../Hint.types';

import INFO from './_assets/info.svg';

export const ICON_MAPPING: Record<HintVariant, string> = {
  info: INFO,
};
